function imageBackground(image) {
  const [imageUrl, imageFocus] = image,
        backgroundStyles = {};

  if (imageUrl !== undefined) {
    backgroundStyles.backgroundImage = `url(${imageUrl})`;
    if (imageFocus !== undefined) {
      backgroundStyles.backgroundPosition = imageFocus;
    }
  }
  return backgroundStyles;
}

export {
  imageBackground
};



// WEBPACK FOOTER //
// ./presenterHelper.js